import { render, staticRenderFns } from "./ResultCard.vue?vue&type=template&id=6d61cb6a&scoped=true"
import script from "./ResultCard.vue?vue&type=script&lang=js"
export * from "./ResultCard.vue?vue&type=script&lang=js"
import style0 from "./ResultCard.vue?vue&type=style&index=0&id=6d61cb6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61cb6a",
  null
  
)

export default component.exports